export default theme => ({
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '6px 0',
  },
  label: {
    fontWeight: 300,
    color: theme.palette.textColor.secondary,
  },
  submitButton: {
    padding: 0,
    minWidth: 'max-content',
    color: theme.palette.textColor.primary,
    '&:hover': {
      color: theme.palette.textColor.primary,
      background: `${theme.palette.background.transparent} !important`,
    },
    '&:focus': {
      color: theme.palette.textColor.primary,
      background: `${theme.palette.background.transparent} !important`,
    },
  },
  submissionRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '6px 0',
    gap: 12,
  },
  leftPart: {
    flex: 1,
    minWidth: 0,
    wordBreak: 'break-word',
  },
  signIcon: {
    marginRight: 10,
  },
  signature: {
    cursor: 'pointer',
    whiteSpace: 'nowrap',
  },
});
